import Preview from './Preview'
import DiscussionCreateMain from './DiscussionCreateMain'
import DiscussionListen from './DiscussionListen'

export default {
  Preview,
  DiscussionCreateMain,
  DiscussionListen
}
